import { PropsWithChildren } from "react";

import { RefreshContext } from "./context";
import { RefreshMachineInput } from "./machine";
import { useRefreshTimer } from "./hooks";

export const RefreshContextProvider = ({
  children,
  ...input
}: PropsWithChildren<RefreshMachineInput>) => {
  const refreshTimer = useRefreshTimer(input);

  return <RefreshContext.Provider value={refreshTimer}>{children}</RefreshContext.Provider>;
};
